import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import ComboBox from "../core/ComboBox";

const contactDisplayName = (contact) =>
  `${contact.first_name || ""} ${contact.last_name || ""}`.trim();

const ContactComboBoxSelect = ({
  contacts = [],
  selectedContactId,
  onSelect,
  showComboBox,
  onToggle,
  onClose,
  emptyLabel = "Select a Contact",
  disabled = false,
  error = false,
  triggerId,
}) => {
  const containerRef = useRef(null);
  const selectedContact = contacts.find(
    (contact) => String(contact.user_id) === String(selectedContactId)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    if (showComboBox) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showComboBox, onClose]);

  const handleSelect = (contactId) => {
    onSelect(contactId);
    onClose();
  };

  const triggerClassName = [
    "combo-box-select-trigger",
    error ? "is-invalid" : "",
    disabled ? "is-disabled" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="combo-box-select" ref={containerRef}>
      <div
        id={triggerId}
        role="button"
        tabIndex={disabled ? -1 : 0}
        className={triggerClassName}
        onClick={() => {
          if (!disabled) onToggle();
        }}
        onKeyDown={(e) => {
          if (disabled) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <span
          className={`combo-box-select-text${
            selectedContact ? "" : " is-placeholder"
          }`}
        >
          {selectedContact
            ? contactDisplayName(selectedContact)
            : emptyLabel}
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`combo-box-select-chevron${
            showComboBox ? " is-open" : ""
          }`}
        />
      </div>
      {showComboBox && !disabled && (
        <div className="combo-box-select-dropdown">
          <ComboBox
            data={contacts}
            selected={selectedContact ? [selectedContact] : []}
            valueKey="user_id"
            placeholder="Search contacts..."
            searchTopic="contact"
            formatData={contactDisplayName}
            handleSelect={handleSelect}
            onRequestClose={onClose}
            inline={false}
          />
        </div>
      )}
    </div>
  );
};

export default ContactComboBoxSelect;
